import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WebhooksTableRow.scss';
import { useTranslation } from 'react-i18next';
import { WhisperComponent } from '../page-components/WhisperComponent';
import { useLocation } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { IAuthState } from '../../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { checkRoles, CLAIMS } from '../../../utils/roles-helper';

export interface IRowData {
	endpointUrl: string;
	subscriberId: string;
	eventName: string;
	id: string;
	onDeleteClick: () => void
}


export const WebhooksTableRow = (props: IRowData): JSX.Element => {
	const { endpointUrl, eventName, id, onDeleteClick } = props;
	const navigate = useNavigate();
	const { pathname, state } = useLocation();
	const { t } = useTranslation();
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

	const onEditClick = (): void => {
		return navigate(`${pathname}/${id}`, { state: { pageNumber: state?.pageNumber, pageSize: state?.pageSize }});
	};

	const actionButtons = [
		{
			key: 'edit',
			title: 'WEBHOOKS.EDIT',
			icon: faPenToSquare,
			action: onEditClick
		},
		{
			key: 'delete',
			title: 'WEBHOOKS.DELETE',
			icon: faTrashCan,
			action: onDeleteClick
		},
	];

	return (
		<tr>
			<td>
				<WhisperComponent
					whisperText={endpointUrl}
					mainText={endpointUrl}
					placement="autoVertical"
					additionalClass="d-block fw-bolder fs-6 text-truncate w-100px w-md-300px w-xl-400px w-xxl-600px"
				/>
			</td>
			<td className="title-length text-truncate">
				{eventName}
			</td>
			{
				!checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN) && (
					<td>
						<div className="d-flex align-items-center title-length">
							{actionButtons.map(({ key, title, icon, action }) => (
								<div
									key={key}
									className="action-btn cursor-pointer"
									onClick={action}
								>
									<FontAwesomeIcon icon={icon}/>
									<span className="fs-7 fw-bolder action-btn-text">
			                {t(title)}
			            </span>
								</div>
							))}
						</div>
					</td>
				)
			}
		</tr>

	);
};
